// Application routes configuration
import React from 'react';
import HomePage from './HomePage';
import GenerateConfigPage from './GenerateConfigPage';
import AccessDeniedPage from './AccessDeniedPage';
import SignInPage from './SignInPage';
import RedirectPage from './RedirectPage';
import ErrorPage from './ErrorPage';


export const NAVIGATION_ROUTES = [
  {
    section: "Authentication",
    title: "Sign In",
    path: "/",
    component: <SignInPage />,
  },
  {
    section: "Main",
    title: "Home",
    path: "/home",
    component: <HomePage />,
  },
  {
    section: "Main", 
    title: "Form",
    path: "/generateconfigpage",
    component: <GenerateConfigPage />,
  },
  {
    section: "System",
    title: "Access Denied",
    path: "/access-denied",
    component: <AccessDeniedPage />,
  },
  {
    section: "System",
    title: "Redirect",
    path: "/redirect",
    component: <RedirectPage />,
  },
  {
    section: "System",
    title: "Error",
    path: "/error",
    component: <ErrorPage />,
  },
];